







"use strict";

const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const moment = require("moment");

const constant = {
    




    versionOfDevice: {
        defaultSettingDeviceVersion: "2.999.999",
        defaultSettingFormatVersion: "2.1.0"
    },
    




    versionOfSetting: {
        default: "0.0.0"
    },
    




    scheduledDatetime: {
        minDiffHours: 12,
        maxDiffHours: 15 * 24
    }
};

class Util {
    modalWindow(elem, cmdOrOptions, ...args) {
        elem = (typeof elem === "string") ? $(elem) : elem;
        let func = (elem._xuxModalWindow || elem.xuxModalWindow).bind(elem);
        return func(cmdOrOptions, ...args);
    }

    patchModalWindow(elem) {
        elem = (typeof elem === "string") ? $(elem) : elem;
        elem._xuxModalWindow = elem.xuxModalWindow.bind(elem);
        elem.xuxModalWindow = (...args) => this.modalWindow(elem, ...args);
        return elem;
    }

    afterLoginApply(app, order, viewName) {
        $("#transferPage").remove();

        app.l10n.localize("body");
        $("article").xuxBoundingBox();
        $("#memo").xuxTextField({width: "full"});
        $(".register-order").xuxApplyBoxAndLayout({width: "full"});
        if (app.session.tenant.isFXTenant && !storage.getItem("orderId")) {
            $("#" + viewName).hide();
            order.openOrderList(app, viewName);
        }
        $("#orderId").text(storage.getItem("orderId"));
        let orderComment = storage.getItem("orderComment");
        $("#orderComment").text(orderComment);
        $("#orderComment").prop("title", orderComment);

        let serviceName = " - " + window.localizedTextMessages.com.label.serviceName;
        switch (viewName) {
        case "settings":
            $("title.p2p-title").text(window.localizedTextMessages.com.label.setting + serviceName);
            break;

        case "device":
            $("title.p2p-title").text(window.localizedTextMessages.com.label.device + serviceName);
            break;

        case "history":
            $("title.p2p-title").text(window.localizedTextMessages.com.label.history + serviceName);
            break;

        case "remote":
            $("title.p2p-title").text(window.localizedTextMessages.com.label.instruction + serviceName);
            break;
        }
    }

    initSupportMenu(app) {
        let isAPOTenant = app.session.tenant.isAPOTenant;
        if (isAPOTenant) {
            $("#supportPage").remove();
        }
        $("#supportmenu").xuxContextMenu({
            select(event, params) {
                let menuItem = $(params.item);
                if (!menuItem) {
                    return;
                }
                switch (menuItem.attr("id")) {
                case "supportPage":
                    window.open("https://fujifilm.com/fb/support/service/device_settings_backup");
                    break;
                case "privacyPolicy":
                    if (isAPOTenant) {
                        window.open("https://direct-fb.fujifilm.com/ap2/rd/l_privacy_policy");
                    } else {
                        window.open("https://direct-fb.fujifilm.com/ap1/rd/l_privacy_policy");
                    }
                    break;
                default:
                    break;
                }
            }
        });
        $("nav.xux-utilityLinksNav span.xux-icon-ellipsisvert").xuxContextMenuTrigger({
            menu: $("#supportmenu")
        });
    }

    initLogoutMenu(app) {
        $("#logoutMenu").xuxContextMenu({
            select() {
                app.logout();
            }
        });
        $("nav.xux-utilityLinksNav a.xux-login").xuxContextMenuTrigger({
            menu: $("#logoutMenu")
        });
    }

    






    messageBoxError(error, callback) {
        let {title, message} = this.makeErrorMessage(error);

        return this.message({
            type: "fault",
            title,
            message,
            yesBtnMsg: window.localizedTextMessages.com.btn.close,
            callbackObj: {
                ok: callback
            }
        });
    }

    




    makeErrorMessage(error) {
        if (typeof error === "string") {
            error = {type: error};
        }
        let errorType = error.type;
        let infoToSupport = error.infoToSupport;
        if (errorType && errorType.lastIndexOf("/") !== -1) {
            errorType = errorType.substring(errorType.lastIndexOf("/") + 1);
        }
        
        let errorMessage = window.localizedTextMessages.errorMsg[errorType];
        if (error.specificParameters) {
            for (let index in error.specificParameters) {
                if (Object.prototype.hasOwnProperty.call(error.specificParameters, index)) {
                    errorMessage = errorMessage.replace("%(" + index + ")", error.specificParameters[index]);
                }
            }
        }
        
        let subErrorMessage = window.localizedTextMessages.errorMsg[errorType + "_sub"];
        subErrorMessage = subErrorMessage && subErrorMessage.replace(
            "%(com.btn.close)", window.localizedTextMessages.com.btn.close);

        
        let supportMessage = "";
        let session = JSON.parse(storage.getItem("appSessionContent") || "null");
        let {isAPOTenant} = (session || {}).tenant || {};
        if (error.callsSupport === true || error.callsSupport === "true") {
            if (isAPOTenant) {
                supportMessage = window.localizedTextMessages.errorMsg.callsSupportTrueAP;
            } else {
                supportMessage = window.localizedTextMessages.errorMsg.callsSupportTrue;
            }
        } else if (error.callsSupport === "trueAfterRetry" || error.retryable) {
            if (isAPOTenant) {
                supportMessage = window.localizedTextMessages.errorMsg.callsSupportTrueAfterRetryAP;
            } else {
                supportMessage = window.localizedTextMessages.errorMsg.callsSupportTrueAfterRetry;
            }
        }

        
        let supportId = (infoToSupport && infoToSupport.supportId) || "";
        supportMessage = supportMessage && supportMessage.replace("%(supportId)", supportId);

        let message = [errorMessage, subErrorMessage, supportMessage]
            .filter(x => !!x)
            .join("<br>");

        
        let title = (error.type === "communicationError") ?
            window.localizedTextMessages.com.title.communicationError :
            window.localizedTextMessages.com.title.error;
        
        if (infoToSupport && infoToSupport.code) {
            title += " (" + infoToSupport.code + ")";
        }

        return {
            title,
            message
        };
    }

    













    message(option) {
        
        return new Promise((resolve, reject) => {
            let dialog = this.patchModalWindow($("<div style='display: none;'></div>"));

            $("body").append(dialog);
            dialog.append("<h2 class='title'></h2>");
            dialog.append("<p class='message'></p>");

            if (option.flag === "2") {
                dialog.append('<button class="cancel" type="button t-t">' + window.localizedTextMessages.com.btn.cancel + "</button>");
            }
            dialog.append('<button class="ok" type="button">' + (option.yesBtnMsg ?
                option.yesBtnMsg : "OK") + "</button>");
            dialog.children("h2.title").append(option.title);
            dialog.children("p.message").html(option.message);

            let closeDialog = isResolve => {
                if ($.data(dialog[0], "xux-xuxModalWindow")) {
                    dialog.xuxModalWindow("close");
                }
                dialog.length && dialog.remove();
                if (typeof isResolve === "boolean") {
                    resolve(isResolve);
                } else {
                    reject(isResolve);
                }
            };
            let resolveTrue = () => closeDialog(true);
            let resolveFalse = () => closeDialog(false);

            dialog.children("button.ok").unbind("click").click(() => {
                try {
                    let okResult;
                    if (option.callbackObj && $.isFunction(option.callbackObj.ok)) {
                        okResult = option.callbackObj.ok(option.callbackObj.okParams);
                    }
                    if (okResult && $.isFunction(okResult.then)) {
                        dialog.hide();
                        okResult.then(resolveTrue).catch(closeDialog);
                    } else {
                        closeDialog(true);
                    }
                } catch (err) {
                    closeDialog(err);
                }
            });
            dialog.children("button.cancel").unbind("click").click(() => {
                try {
                    let cancelResult;
                    if (option.callbackObj && $.isFunction(option.callbackObj.cancel)) {
                        cancelResult = option.callbackObj.cancel(option.callbackObj.cancelParams);
                    }
                    if (cancelResult && $.isFunction(cancelResult.then)) {
                        dialog.hide();
                        cancelResult.finally(resolveFalse);
                    } else {
                        closeDialog(false);
                    }
                } catch (err) {
                    closeDialog(err);
                }
            });

            dialog.xuxModalWindow({
                type: option.type
            });
            dialog.find("span.message").closest("div").css({
                "max-height": "165px",
                "overflow-y": "auto"
            });
            dialog.xuxModalWindow("open");
        });
    }

    isParamEmpty(param, flag) {
        if (param && typeof param === "string") {
            param = this.trim(param);
        }
        if (param === undefined || param === null || param === "" || param.length === 0) {
            return true;
        } else if (flag && JSON.parse(param).length === 0) {
            return true;
        }
        return false;
    }

    trim(str) {
        let start = 0, end = 0;
        for (let i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) !== 32) {
                start = i;
                break;
            }
        }
        for (let i = str.length - 1; i >= 0; i--) {
            if (str.charCodeAt(i) !== 32) {
                end = i + 1;
                break;
            }
        }
        return str.substring(start, end);
    }

    logOutHeader(app) {
        $("header").xuxHeader({
            loginout: true,
            user: app.session.userName
        });
        $("#logoutMenu").find("a").append("<span class = 'xux-icon xux-icon-exit'></span>" +
        window.localizedTextMessages.com.label.logout);
    }

    setTimeDropdown(hourDropdown, minuteDropdown) {
        let hourStr = "";
        for (let hour = 0; hour < 24; hour++) {
            hourStr += "<option value='" + hour + "'>" + hour + "</option>";
        }
        hourDropdown.append(hourStr);
        let minuteStr = "", limit = 10;
        for (let times = 0; times < 6; times++) {
            let startIndex = times * limit;
            minuteStr += "<option value='" + startIndex + "'>" + startIndex + "</option>";
        }
        minuteDropdown.append(minuteStr);
    }

    














    messageAlertTable(option) {
        
        option = Object.assign({
            type: "default",
            fitFlag: false,
            yesBtnMsg: window.localizedTextMessages.com.btn.ok,
            noBtnMsg: window.localizedTextMessages.com.btn.cancel,
            thead: [],
            data: [],
        }, option);

        const xuxOptions = {
            height: option.fitFlag ? "fit" : "auto",
            type: option.type,
        };

        if (option.width) {
            xuxOptions.width = option.width;
        }

        let alertTableWindow = this.patchModalWindow("#alert-table-window")
            .xuxModalWindow(xuxOptions);

        $("#alert-message-table").empty().append("<div><table id='alert-table'><thead><tr></tr></thead><tbody><tr></tr></tbody></table></div>");
        alertTableWindow.find("thead tr").empty();
        $("#alert-table-yes").find("span").text(option.yesBtnMsg);
        $("#alert-table-cancel").find("span").text(option.noBtnMsg);
        $.each(option.thead, (i, name) => {
            $("#alert-table").find("thead tr").append("<th></th>");
            $("#alert-table").find("thead tr").find("th:last").empty().append(window.localizedTextMessages[name.split(".")[0]][name.split(".")[1]][name.split(".")[2]]);
        });

        $("#alert-table-window h2").empty().append(option.title);
        $("#alert-table-message").empty().append(option.message);
        $("div.message-down").empty().append(option.messageDown).toggleClass("message-hide", !option.messageDown);

        $("#alert-table tbody").empty();
        $.each(option.data, (_, data) => {
            let tr = $(option.tbody(data));
            tr.find("td").each((index, td) => {
                $(td).prop("title", $(td).text());
                $(td).children("div").addClass("message-table-contentEllipsis");
            });
            $("#alert-table tbody").append(tr);
        });
        $("#alert-table").xuxTable({
            selectionControl: "none",
            multipleSelections: false
        });
        $("#alert-table-yes").unbind("click").click(() => {
            option.yes && option.yes();
            alertTableWindow.xuxModalWindow("close");
        });
        $("#alert-table-cancel").unbind("click").click(() => {
            alertTableWindow.xuxModalWindow("close");
        });

        alertTableWindow.xuxModalWindow("open");
    }

    getDate(date) {
        let timeZone;
        let tempDate;
        let formatDate;
        let dateSplit;
        if (date.split("-").length > 3) {
            tempDate = date.replace("-", "/").replace("-", "/").replace("T", " ").replace("-", " -");
        } else {
            tempDate = date.replace(/-/g, "/").replace("T", " ").replace("+", " +");
        }
        if (tempDate.indexOf("+") !== -1) {
            formatDate = tempDate.split("+")[0];
            timeZone = tempDate.split("+")[1];
            dateSplit = "+";
        }
        if (tempDate.indexOf("-") !== -1) {
            formatDate = tempDate.split("-")[0];
            timeZone = tempDate.split("-")[1];
            dateSplit = "-";
        }
        formatDate = formatDate + dateSplit + timeZone.split(":")[0];
        return new Date(formatDate);
    }

    limitAssignationTime() {
        const {minDiffHours, maxDiffHours} = constant.scheduledDatetime;
        let maxDatetime = moment().add(maxDiffHours, "hours").format("YYYY-MM-DD");
        let minDatetime;
        let currentHour = new Date().getHours(), currentMinutes = new Date().getMinutes();
        if (currentHour + minDiffHours >= 24 ||
            (currentHour + minDiffHours === 23 && currentMinutes > 50)) {
            minDatetime = moment().add(1, "day").format("YYYY-MM-DD");
        } else {
            minDatetime = moment().format("YYYY-MM-DD");
        }
        $("#date").attr("min", minDatetime);
        $("#date").attr("max", maxDatetime);
        $("#date").xuxDateField("refresh");
    }

    checkDate(assignationTime) {
        let minTime = moment().add(constant.scheduledDatetime.minDiffHours, "hours");
        if (!assignationTime.isValid() || assignationTime.isBefore(minTime)) {
            this.message({
                title: window.localizedTextMessages.errorMsg.wrongInstructionTime,
                yesBtnMsg: window.localizedTextMessages.com.btn.close
            }).finally(() => {
                this.closeDialog();
            });
            return false;
        } else {
            return true;
        }
    }

    text(text) {
        return $("<span/>").text(text).html();
    }

    







    _checkVersion(versionOfDevice, versionOfSetting) {
        let versionsOfDevice = versionOfDevice.split(".");
        let versionsOfSetting = (versionOfSetting || constant.versionOfSetting.default).split(".");
        for (let i = 0; i < 2; i++) {
            let versionOfD = (versionsOfDevice.length > i && Number(versionsOfDevice[i])) || 0;
            let versionOfS = (versionsOfSetting.length > i && Number(versionsOfSetting[i])) || 0;
            if (versionOfD !== versionOfS) {
                return versionOfD > versionOfS;
            }
        }
        
        
        return true;
    }

    






    checkDeviceVersion(versionOfDevice, versionOfSetting) {
        return this._checkVersion(
            versionOfDevice || constant.versionOfDevice.defaultSettingDeviceVersion,
            versionOfSetting);
    }

    






    checkFormatVersion(versionOfDevice, versionOfSetting) {
        return this._checkVersion(
            versionOfDevice || constant.versionOfDevice.defaultSettingFormatVersion,
            versionOfSetting);
    }

    




    countryIsJapan(countryCode) {
        
        return [null, undefined, "392"].includes(countryCode);
    }

    





    checkCountryCode(codeOfDevice, codeOfSetting) {
        
        if (codeOfDevice === codeOfSetting) {
            return true;
        }
        const deviceIsJapan = this.countryIsJapan(codeOfDevice);
        const settingIsJapan = this.countryIsJapan(codeOfSetting);
        
        if (deviceIsJapan && settingIsJapan) {
            return true;
        } else if (!deviceIsJapan && !settingIsJapan) {
            
            if (codeOfSetting === "") {
                return true;
            }
        }
        return false;
    }
}

module.exports = Util;
